import { z } from 'zod';
import { SafeStringSchema } from '../types/CommonSchemas';

export const ModemStatisticSchema = z.object({
    imei: SafeStringSchema,
    userName: SafeStringSchema,
    comment: SafeStringSchema,
    lifetime: z.number(),
    name: SafeStringSchema,
    version: SafeStringSchema,
    statId: SafeStringSchema
});

export type ModemStatisticData = z.infer<typeof ModemStatisticSchema>;

export const ModemStatisticListSchema = z.array(ModemStatisticSchema);

export type ModemStatisticDataList = z.infer<typeof ModemStatisticListSchema>;

export const VisitsByDaySchema = z.object({
    date: z.iso.datetime(),
    count: z.int()
});

export type VisitsByDayData = z.infer<typeof VisitsByDaySchema>;

export const VisitsByDayListSchema = z.array(VisitsByDaySchema);

export type VisitsByDayDataList = z.infer<typeof VisitsByDayListSchema>;

export const LifetimeStatisticSchema = z.object({
    imei: SafeStringSchema,
    email: SafeStringSchema,
    lifetime: z.number(),
    // not in api
    firmwareVersion: z.int(),
    modemVersion: z.int()
});

export type LifetimeStatisticData = z.infer<typeof LifetimeStatisticSchema>;

export const LifetimeStatisticListSchema = z.array(LifetimeStatisticSchema);

export type LifetimeStatisticDataList = z.infer<typeof LifetimeStatisticListSchema>;

export const FullStatisticSchema = z.object({
    uniqueVisitsByDay: z.preprocess(
        (val) => (val === null ? [] : val),
        VisitsByDayListSchema,
    ),
    lifetimeStatistic: z.preprocess(
        (val) => (val === null ? [] : val),
        LifetimeStatisticListSchema,
    )
});

export type FullStatisticData = z.infer<typeof FullStatisticSchema>;

export const StatisticGetLogsSizeSchema = z.number();

export type StatisticGetLogsSizeData = z.infer<typeof StatisticGetLogsSizeSchema>;

export const LogInfoSchema = z.object({
    time: z.iso.datetime(),
    level: z.number(),
    machineName: SafeStringSchema,
    message: SafeStringSchema,
    trace: SafeStringSchema,
});

export type LogInfoData = z.infer<typeof LogInfoSchema>;

export const LogInfoListSchema = z.array(LogInfoSchema);

export type LogInfoDataList = z.infer<typeof LogInfoListSchema>;

export interface StatisticGetModemStatisticRequestData {
    imei: string;
    email: string;
}

export interface StatisticSetModemCommentRequestData {
    comment: string;
    statId: string;
}
